// pages/Dashboard.tsx
import React, { useEffect, useState } from "react";
import { Button, Radio } from "antd";
import { useAuth } from "../context/AuthContext";
import LinkCard from "../components/misc/LinkCard";
import { Clipboard } from "react-feather";
import InfoCard from "../components/misc/InfoCard";
import AnalyticsService from "../services/analytics.service";
import dayjs from "dayjs";
import {
  PeriodicMetric,
  StaffWithPerformance,
} from "../entities/interfaces/analytics";
import StaffPerfomanceComponent from "../components/dashboard/StaffPerformance";
import WithPermission from "../components/misc/WithPermission";

const Dashboard: React.FC = () => {
  const { user } = useAuth();
  const [date, setDate] = useState({
    from: dayjs().startOf("date").toISOString(),
    to: dayjs().endOf("date").toISOString(),
  });
  const [periodic, setPeriodic] = useState<PeriodicMetric>({
    numOfOrders: 0,
    totalSales: 0,
    totalServicesRendered: 0,
  });
  const [staffPerformance, setStaffPerformance] = useState<
    StaffWithPerformance[]
  >([]);

  useEffect(() => {
    getPeriodicMetric(date.from, date.to);
    getStaffPerformance(date.from, date.to);
  }, [date]);

  const getPeriodicMetric = async (from: string, to: string) => {
    const res = await AnalyticsService.periodicMetric(from, to);
    if (res) {
      setPeriodic(res.data);
    }
  };

  const getStaffPerformance = async (from: string, to: string) => {
    const res = await AnalyticsService.staffPerformance(from, to);
    if (res) {
      setStaffPerformance(res.data);
    }
  };

  const onFilterChange = (value: dayjs.OpUnitType) => {
    setDate({
      from: dayjs().startOf(value).toISOString(),
      to: dayjs().endOf(value).toISOString(),
    });
  };

  return (
    <div>
      <div className="flex justify-between">
        <h2 className="font-semibold text-lg mb-5">Dashboard</h2>
        <WithPermission permission="list:dashboard">
          <Radio.Group
            defaultValue="date"
            buttonStyle="solid"
            onChange={(e) => onFilterChange(e.target.value)}
          >
            <Radio.Button value="date">Today</Radio.Button>
            <Radio.Button value="week">This Week</Radio.Button>
            <Radio.Button value="month">This Month</Radio.Button>
          </Radio.Group>
        </WithPermission>
      </div>
      {user?.role === "STAFF" && (
        <LinkCard
          icon={<Clipboard />}
          title="Create Order"
          link="/orders/create"
        />
      )}
      <WithPermission permission="list:dashboard">
        <>
          <div className="flex gap-4 mb-8">
            <InfoCard
              title="Total Sales"
              value={`₹${periodic.totalSales}`}
              link="/reports"
            />
            <InfoCard title="Total Orders" value={periodic.numOfOrders} />
            <InfoCard
              title="Total Services Done"
              value={periodic.totalServicesRendered}
            />
          </div>
          <StaffPerfomanceComponent data={staffPerformance} />
        </>
      </WithPermission>
    </div>
  );
};

export default Dashboard;
